import React, { useState } from 'react';
import Layout from '../../components/Layout';
import { toast } from 'react-toastify';
import { post } from '../../controllers/apiController';
import { useEffect } from 'react';

const MusteriTipiEkle = () => {
    const [customerTypeName, setCustomerTypeName] = useState("");
    const [customerTypeBgColor, setCustomerTypeBgColor] = useState("#000000");
    const [customerTypeTextColor, setCustomerTypeTextColor] = useState("#000000");

    useEffect(() => {
        document.title = "Müşteri Tipi Ekle | LEVELUP CRM";
    }, []);

    const createCustomerType = async () => {
        if (customerTypeName === "" || customerTypeBgColor === "" || customerTypeTextColor === "") {
            toast.error('Lütfen tüm alanları doldurunuz');
            return;
        }

        try {
            await post("customer-types", {
                customerTypeName: customerTypeName,
                customerTypeBgColor: customerTypeBgColor,
                customerTypeTextColor: customerTypeTextColor
            });

            setCustomerTypeName("");
            setCustomerTypeBgColor("#000000");
            setCustomerTypeTextColor("#000000");

            toast.success('Müşteri tipi başarıyla oluşturuldu');
        } catch (err) {
            toast.error("Müşteri tipi oluşturulurken bir hata oluştu!");
        }
    }

    return (
        <Layout>
            <main className="nxl-container">
                <div className="nxl-content">
                    <div className="page-header">
                        <div className="page-header-left d-flex align-items-center">
                            <div className="page-header-title">
                                <h5 className="m-b-10">LEVELUP CRM</h5>
                            </div>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><a href="./">Anasayfa</a></li>
                                <li className="breadcrumb-item"><a href="./customer-types">Müşteri Tipleri</a></li>
                                <li className="breadcrumb-item">Oluştur</li>
                            </ul>
                        </div>
                    </div>
                    <div className="main-content">
                        <div className="row">
                            <div className="col-xxl-12 col-md-12">
                                <div className="card stretch stretch-full">
                                    <div className="card-body">
                                        <div class="mb-5 d-flex align-items-center justify-content-between">
                                            <h5 class="fw-bold mb-0 me-4">
                                                <span class="d-block mb-2">Müşteri Tipi Bilgileri:</span>
                                            </h5>
                                        </div>
                                        <div className="row mb-4 align-items-center">
                                            <div className="col-lg-4">
                                                <label for="customerTypeName" className="fw-semibold">Müşteri Tipi Başlığı: </label>
                                            </div>
                                            <div className="col-lg-8">
                                                <div className="input-group">
                                                    <div className="input-group-text"><i className="feather-tag"></i></div>
                                                    <input type="text" className="form-control" id="customerTypeName" placeholder="Müşteri Tipi Başlığı" onChange={(e) => setCustomerTypeName(e.target.value)} value={customerTypeName} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-4 align-items-center">
                                            <div className="col-lg-4">
                                                <label for="customerTypeBgColor" className="fw-semibold">Müşteri Tipi Arka Plan Rengi: </label>
                                            </div>
                                            <div className="col-lg-8">
                                                <div className="input-group">
                                                    <div className="input-group-text"><i className="feather-layers"></i></div>
                                                    <input type="color" className="form-control form-control-color" id="customerTypeBgColor" onChange={(e) => setCustomerTypeBgColor(e.target.value)} value={customerTypeBgColor} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-4 align-items-center">
                                            <div className="col-lg-4">
                                                <label for="customerTypeTextColor" className="fw-semibold">Müşteri Tipi Yazı Rengi: </label>
                                            </div>
                                            <div className="col-lg-8">
                                                <div className="input-group">
                                                    <div className="input-group-text"><i className="feather-underline"></i></div>
                                                    <input type="color" className="form-control form-control-color" id="customerTypeTextColor" onChange={(e) => setCustomerTypeTextColor(e.target.value)} value={customerTypeTextColor} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mt-3 d-flex justify-content-start">
                                            <button onClick={createCustomerType} className="btn btn-primary">
                                                <i className="feather-plus me-2"></i>
                                                <span>Müşteri Tipi Oluştur</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </main>
        </Layout>
    );
};

export default MusteriTipiEkle;
